<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="4">
        <v-alert dense text type="info">
          {{ counter }} registros encontrados
        </v-alert>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn color="primary" @click="register()" block v-if="$auth.check('ROLE_ADMIN')">+</v-btn>
      </v-col>
    </v-row>
    <v-progress-linear indeterminate color="primary" class="mb-2" v-if="loading"></v-progress-linear>
    <v-simple-table>
      <thead>
        <tr>
          <th>Código</th>
          <th>Nome</th>
          <th>Host</th>
          <th>Interfaces</th>
          <th>ONTs</th>
          <th>UP</th>
          <th>DOWN</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.code }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.host }}</td>
          <td>
            <span v-if="item.failed">-</span>
            <span v-else>{{ item.interfaces }}</span>
          </td>
          <td>{{ item.onts }}</td>
          <td class="success--text">
            <span v-if="item.failed">-</span>
            <span v-else>{{ item.up }}</span>
          </td>
          <td class="error--text">
            <span v-if="item.failed">-</span>
            <span v-else>{{ item.down }}</span>
          </td>
          <td style="white-space: nowrap">
            <v-btn small color="primary" @click="view(item.id)" v-if="$auth.check('ROLE_ADMIN')">configuração</v-btn>&nbsp;&nbsp;
            <v-btn small color="success" @click="admin(item.id)">administração</v-btn>&nbsp;&nbsp;
            <v-btn small color="warning" @click="status(item.id)">status</v-btn>&nbsp;&nbsp;
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    counter: 0,
    loading: false
  }),
  created: function() {
    this.list();
  },
  methods: {
    list: function() {
      var me = this;
      var token = localStorage.getItem("token");
      var config = { headers: { Authorization: "Bearer " + token } };
      me.loading = true;
      api
        .get("/olt", config)
        .then(function(response) {
          var olts = response.data || [];
          olts.forEach(function(olt) {
            olt.interfaces = 0;
            olt.onts = 0;
            olt.up = 0;
            olt.down = 0;
            olt.failed = false;
          });
          me.current = olts;
          me.counter = olts.length;
          me.listOnt();
          return Promise.all(
            olts.map(function(olt) {
              return api
                .get("/olt_service_port/status/" + olt.id, config)
                .then(function(res) {
                  me.processSP(olt, res.data || []);
                })
                .catch(function(error) {
                  console.log(error);
                  olt.failed = true;
                });
            })
          );
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
          me.loading = false;
        });
    },
    listOnt: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/ont", { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          var cache = {};
          (response.data || []).forEach(function(ont) {
            cache[ont.oltId] = (cache[ont.oltId] || 0) + 1;
          });
          me.current.forEach(function(olt) {
            olt.onts = cache[olt.id] || 0;
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    processSP: function(olt, sports) {
      let cache = {};
      let up = 0;
      let down = 0;
      for (var i = 0; i < sports.length; i++) {
        const sp = sports[i];
        cache[sp.fsp] = true;
        if (sp.status == "up") {
          up++;
        } else if (sp.status == "down") {
          down++;
        }
      }
      olt.interfaces = Object.keys(cache).length;
      olt.up = up;
      olt.down = down;
    },
    view: function(id) {
      this.$router.push({ path: `/olt/${id}` });
    },
    register: function() {
      router.push({ path: "/olt/0" });
    },
    admin: function(id) {
      this.$router.push({ path: `/olt/admin/${id}` });
    },
    status: function(id) {
      this.$router.push({ path: `/olt/status/${id}` });
    }
  }
};
</script>
